var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-card', [_c('b-card-title', [_c('h3', [_vm._v("Tasks by Phase")])]), _c('b-card-text', [_c('div', [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "md": "6",
      "lg": "6",
      "xs": "12"
    }
  }, [_c('v-select', {
    staticClass: "mr-sm-1 mb-1 mb-sm-0 custom-font",
    attrs: {
      "options": _vm.filterProjectIdOption,
      "reduce": function reduce(task) {
        return task.id;
      },
      "label": "name",
      "placeholder": "Select Project"
    },
    on: {
      "input": _vm.filterProject
    },
    model: {
      value: _vm.filterProjectId,
      callback: function callback($$v) {
        _vm.filterProjectId = $$v;
      },
      expression: "filterProjectId"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "6",
      "xs": "12"
    }
  }, [_c('v-select', {
    staticClass: "custom-font",
    attrs: {
      "options": _vm.filterMilestoneBoardIdOption,
      "reduce": function reduce(item) {
        return item.id;
      },
      "label": "name",
      "placeholder": "Select Milestone Board"
    },
    on: {
      "input": _vm.getPhaseData
    },
    model: {
      value: _vm.filterBoardListMilestoneId,
      callback: function callback($$v) {
        _vm.filterBoardListMilestoneId = $$v;
      },
      expression: "filterBoardListMilestoneId"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "chart-container d-flex justify-content-center align-items-center"
  }, [_vm.isLoading ? _c('div', {
    staticClass: "d-flex justify-content-center my-3"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary",
      "label": "Loading..."
    }
  })], 1) : _vm.phaseData.length === 0 ? _c('div', {
    staticClass: "text-center my-5"
  }, [!_vm.filterBoardListMilestoneId ? _c('p', [_vm._v("Select a board.")]) : _c('p', [_vm._v("No task data available to display.")])]) : _c('pie-chart', {
    attrs: {
      "chart-data": _vm.chartData,
      "options": _vm.chartOptions,
      "height": 300,
      "selected-indexes": _vm.selectedAssigneeIndexes
    },
    on: {
      "chart-click": _vm.handleChartClick
    }
  })], 1)])], 1), _c('b-modal', {
    attrs: {
      "id": "phase-modal",
      "centered": "",
      "title": _vm.selectedAssignee ? "".concat(_vm.selectedAssignee) : 'Task Distribution by Phase',
      "hide-footer": "",
      "size": "xl",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.closeModal
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "modal-chart d-flex justify-content-center align-items-center"
  }, [_c('pie-chart', {
    ref: "modalPie",
    attrs: {
      "chart-data": _vm.getModalChartData,
      "options": _vm.modalChartOptions,
      "height": 400,
      "selected-indexes": _vm.selectedAssigneeIndexes
    },
    on: {
      "chart-click": _vm.handleChartClick
    }
  })], 1)]), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "modal-task-list"
  }, [_vm.isLoading ? _c('div', {
    staticClass: "d-flex justify-content-center my-3"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary",
      "label": "Loading..."
    }
  })], 1) : _c('div', [_vm.selectedPhaseIds.length > 0 ? _c('DataTable', {
    key: _vm.selectedPhaseIds.join(','),
    attrs: {
      "is-subtask": _vm.isSubtask,
      "show": 10,
      "endpoint": _vm.taskEndpoint
    }
  }) : _vm._e()], 1)])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }